module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("brand.navigation.notificationList")))]), _vm._v(" "), _c('div', {
    staticClass: "create-list"
  }, [_c('div', [_c('TextInputBloc', {
    attrs: {
      "label": _vm.$t('notificationList.createNewList')
    },
    model: {
      value: (_vm.newNotificationList.name),
      callback: function($$v) {
        _vm.newNotificationList.name = $$v
      },
      expression: "newNotificationList.name"
    }
  }), _c('br')], 1), _vm._v(" "), _c('div', {}, [_c('SelectBloc', {
    attrs: {
      "value": _vm.newNotificationList.applicationId,
      "required": true,
      "options": _vm.applicationOptions,
      "label": 'Application'
    },
    on: {
      "change": function($event) {
        _vm.newNotificationList.applicationId = parseInt($event)
      }
    }
  }), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "disabled": !_vm.newNotificationList.name
    },
    on: {
      "click": _vm.createNotificationList
    }
  }, [_vm._v(_vm._s(_vm.$t("common.create")))])], 1)]), _vm._v(" "), _vm._l((_vm.notificationLists), function(list) {
    return _c('div', {
      key: list.id
    }, [_c('NotificationListDetail', {
      attrs: {
        "users": _vm.users,
        "list": list,
        "zones": _vm.zones,
        "applications": _vm.applicationOptions
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbff66aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/notifcation-lists/NotificationLists.vue
// module id = 3367
// module chunks = 0